import { type FC } from "react";
import { Field, Form } from "react-final-form";
import { Button, Card, CardContent, Grid, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { StreamEntrypoint } from "@/partner/entities/streamEntrypoints";
import type { StreamEntrypointFormValues } from "../model";
import { StreamEntrypointAttachField } from "./StreamEntrypointAttachField";

// Общий id формы: Save-кнопка хедера (StreamEntrypointForm.tsx) ссылается
// на неё через атрибут form=, хотя физически рендерится в другом месте DOM.
export const FORM_ID = "stream-entrypoint-form";

interface StreamEntrypointEditTabProps {
  entrypoint: StreamEntrypoint;
  onSubmit: (values: StreamEntrypointFormValues) => void | Promise<void>;
  onDelete: () => void;
  updating: boolean;
  deleting: boolean;
}

// Вкладка «Редактирование»: карточка (название, привязка к трансляции,
// удаление). Мутации и DialogHeader с кнопкой «Сохранить» подняты в шелл
// (StreamEntrypointForm.tsx), чтобы хедер был общим для всех вкладок, как
// у стримов (EditStreamDialog+StreamDialogHeader).
export const StreamEntrypointEditTab: FC<StreamEntrypointEditTabProps> = ({
  entrypoint,
  onSubmit,
  onDelete,
  updating,
  deleting,
}) => {
  const { t } = useTranslation();

  return (
    <Form<StreamEntrypointFormValues>
      onSubmit={onSubmit}
      initialValues={{ title: entrypoint.title }}
      render={({ handleSubmit }) => (
        <form id={FORM_ID} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card elevation={0}>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <Field name="title">
                        {({ input, meta }) => (
                          <TextField
                            {...input}
                            autoFocus
                            required
                            label={t("streamEntrypoints.titleField")}
                            fullWidth
                            variant="outlined"
                            error={meta.touched && Boolean(meta.error)}
                          />
                        )}
                      </Field>
                    </Grid>
                    <Grid size={12}>
                      <StreamEntrypointAttachField
                        entrypointId={entrypoint.id}
                        contentId={entrypoint.stream?.id}
                      />
                    </Grid>
                    <Grid size={12}>
                      <Button
                        color="error"
                        variant="outlined"
                        disabled={deleting || updating}
                        onClick={onDelete}
                      >
                        {t("common.actions.delete")}
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};
